import React, { useEffect, useState } from 'react';
import { usePerformSignoutOperation } from 'components/accessControl/hooks/usePerformSignoutOperation';
import {
  getLatestActivityTime,
  jwtCookieName,
  TIMEOUT_LIMIT,
} from '../../../types/accessControl/AccessControlConstants';
import { DateTime } from 'luxon';
import { IUseTimer } from './IUseTimer';
import Cookies from 'js-cookie';
import type { FCWithChildren } from '../../../types/FCWithChildren';

export const ActivityTimeout: FCWithChildren<IUseTimer> = ({ timer, children }) => {
  const [loggingOut, setLoggingOut] = useState(true);
  const { logout } = usePerformSignoutOperation();

  useEffect(() => {
    const timeRemaining = getLatestActivityTime().plus({ milliseconds: TIMEOUT_LIMIT }).diff(DateTime.now());
    if (timeRemaining.as('milliseconds') < 1000) {
      setLoggingOut(true);
      logout();
      return;
    }
    if (!Cookies.get(jwtCookieName)) {
      setLoggingOut(true);
      logout();
      return;
    }
    setLoggingOut(false);
  }, [timer, logout, setLoggingOut]);

  return <>{!loggingOut && children}</>;
};
